/**
 * Круглая icon-кнопка (как «Назад» в пазле). Стили из ui/tokens.
 */

import { soundManager } from '../../services/SoundManager';

export interface IconButtonOptions {
  ariaLabel: string;
  /** Текст или символ (например "←") */
  iconOrText: string;
  onClick: () => void;
}

export function createIconButton(options: IconButtonOptions): HTMLButtonElement {
  const { ariaLabel, iconOrText, onClick } = options;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ui-btn ui-btn-back';
  btn.setAttribute('aria-label', ariaLabel);
  btn.textContent = iconOrText;
  btn.addEventListener('click', () => {
    soundManager.playClick();
    onClick();
  });
  return btn;
}
